import AppLayout from '../../layouts/AppLayout/AppLayout';
import MainHeader from '../../Components/MainHeader/MainHeader';
import MainFooter from '../../Components/MainFooter/MainFooter';
import AppleSubscriptionPlans from '../../Components/AppleSubscriptionPlans/AppleSubscriptionPlans';

function AppPayPage() {
    return (
        <AppLayout>
            <MainHeader variant="cabinet" />
            <main>
                <AppleSubscriptionPlans />
            </main>
            <MainFooter />
        </AppLayout>
    );
}

export default AppPayPage;
